import {useCallback} from 'react';
import {useSyncExternalStore} from 'use-sync-external-store/shim';

interface ObservableWrapper<T> {
  observable(): {
    subscribe(listener: () => void): {unsubscribe(): void};
  };
  get(): T;
}

export function useSyncConversationObservable<T>(
  wrapper: ObservableWrapper<T>,
): T {
  const subscribe = useCallback(
    (listener: () => void) => {
      const subscription = wrapper.observable().subscribe(listener);
      return () => subscription.unsubscribe();
    },
    [wrapper],
  );

  const getSnapshot = useCallback(() => {
    return wrapper.get();
  }, [wrapper]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
